'use client';

import { useSearchParams } from 'next/navigation';
import { z } from 'zod';

import { resolveChannel } from './project-response-insight-info.helpers';

export function useResponderEmail() {
  const searchParams = useSearchParams();
  const email = searchParams?.get('email');
  const parsedEmail = z.email().safeParse(email);
  return parsedEmail.success ? parsedEmail.data : undefined;
}

export function useChannel() {
  const searchParams = useSearchParams();
  return resolveChannel(searchParams?.get('channel'));
}
